import axios from 'axios';

const doesTeamMlsIdExist = async (teamMlsId: string, teamId?: string) => {
  const {
    data: { exists },
  } = await axios.get(`/team/${teamMlsId}/exists`, { params: { teamId } });
  return exists;
};

export default doesTeamMlsIdExist;
